// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.r6KV0yEdmnh3Op {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: var(--ds-text-inverse, #ffffff);
  font-size: 20px;
  font-weight: var(--ds-font-weight-bold, bold);
}
.r6KV0yEdmnh3Op.oK1Z6on5AlEgj6 {
  font-size: 16px;
}
.r6KV0yEdmnh3Op.WapaHcGFRch1mS {
  font-size: 12px;
}
.hE4NRqctYyPEEi {
  background: linear-gradient(var(--ds-background-accent-blue-bolder, #0747a6), var(--ds-background-accent-teal-bolder, #008da6));
}
.BVceZHOoUszsgw {
  background: linear-gradient(var(--ds-background-accent-green-bolder, #006644), var(--ds-background-accent-green-subtle, #00875a));
}
.AGjl0yEuecYuvs {
  background: linear-gradient(var(--ds-background-accent-purple-bolder, #403294), var(--ds-background-accent-blue-bolder, #0747a6));
}
.ZMB1fo1WNg7X5U {
  background: linear-gradient(var(--ds-background-accent-magenta-bolder, #b22865), var(--ds-background-accent-magenta-subtle, #cd5a91));
}
.KGdu06Bvb12aw8 {
  background: linear-gradient(var(--ds-background-accent-red-bolder, #cc4223), var(--ds-background-accent-orange-subtle, #cb7d25));
}
.ZCvj3qbb9WQa3W {
  background: var(--ds-background-neutral-bold, #42526e);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"defaultLogoContainer": `r6KV0yEdmnh3Op`,
	"xsmall": `oK1Z6on5AlEgj6`,
	"xxsmall": `WapaHcGFRch1mS`,
	"defaultLogoGradient-teal": `hE4NRqctYyPEEi`,
	"defaultLogoGradient-green": `BVceZHOoUszsgw`,
	"defaultLogoGradient-blue": `AGjl0yEuecYuvs`,
	"defaultLogoGradient-pink": `ZMB1fo1WNg7X5U`,
	"defaultLogoGradient-orange": `KGdu06Bvb12aw8`,
	"desaturateLogo": `ZCvj3qbb9WQa3W`
};
export default ___CSS_LOADER_EXPORT___;
